<script>
import MottoIcon from './motto-icon.vue'

export default {
  components: { MottoIcon },
  props: {
    route: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    selectedSubSidebarItem: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    subRoutes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    hasSubRoutes() {
      return !!this.subRoutes.length
    },
  },
  created() {
    if (this.active && this.hasSubRoutes) {
      this.isOpen = true
    }
  },
  methods: {
    handleSidebarClick(route) {
      this.$router.push(route)
    },

    handleSubSidebarClick(route) {
      this.$router.push(route)
    },

    toggleIsOpen() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<template>
  <div :class="{ [$style.sidebarItemWrapper]: true }">
    <div
      :class="{ [$style.sidebarItem]: true, [$style.sidebarItemActive]: active, [$style.sidebarItemOpen]: isOpen }"
      @click="handleSidebarClick(route)">
      <MottoIcon :name="icon" :icon-color="active ? 'white' : 'primary'" :class="$style.sidebarIcon"></MottoIcon>
      <h3 :class="$style.sidebarLabel">{{ label }}</h3>
      <BaseIcon
        v-if="hasSubRoutes"
        :class="$style.chevron"
        :name="isOpen ? 'chevron-up' : 'chevron-down'"
        @click.native.stop="toggleIsOpen"></BaseIcon>
    </div>
    <div v-if="isOpen" :class="{ [$style.subSidebarItemsContainer]: true, [$style.subSidebarActive]: active }">
      <div
        v-for="subRoute in subRoutes"
        :key="subRoute.label"
        :class="{
          [$style.subSidebarItem]: true,
          [$style.selectedSubSidebarItem]: selectedSubSidebarItem === subRoute.name,
        }"
        @click="handleSubSidebarClick(subRoute)">
        <div :class="$style.emptySidebarIcon"></div>
        <h4 :class="[$style.subSidebarLabel]">{{ subRoute.title }}</h4>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

$icon-size: 24px;

.chevron {
  margin: auto 0 auto 18px;
}

.sidebarLabel {
  display: inline;
  line-height: 80px;
  color: $primary-blue;
}

.sidebarItem {
  display: flex;
  width: 100%;
  max-width: 249px;
  height: 80px;
  margin: 0;
  cursor: pointer;
  border-radius: 16px 0 0 16px;
  transition: background-color 0.3s ease;

  .chevron {
    color: $primary-blue;
  }

  &.sidebarItemActive {
    background: $primary-blue;

    .sidebarLabel,
    .chevron {
      color: $white !important;
    }
  }

  &.sidebarItemOpen {
    border-radius: 16px 0 0 0;
  }
}

.subSidebarItemsContainer {
  padding-bottom: 1px;
  border-radius: 0 0 0 16px;
  transition: background-color 0.3s ease;

  .subSidebarLabel {
    font-weight: 700;
    color: $primary-blue;
  }

  &.subSidebarActive {
    background: $primary-blue;

    .subSidebarLabel {
      color: $white;
    }
  }
}

@mixin motto-underline($color) {
  &::after {
    float: left;
    width: 100%;
    height: 3px;
    margin-top: 1px;
    content: '';
    background: $color;
    border-radius: 5px;
  }
}

.subSidebarItem {
  display: flex;
  height: 20px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &.selectedSubSidebarItem {
    .subSidebarLabel {
      @include motto-underline(currentColor);
    }
  }

  &:hover {
    .subSidebarLabel {
      @include motto-underline(currentColor);
    }
  }
}

.sidebarIcon {
  display: block;
  width: $icon-size;
  height: $icon-size;
  margin: auto 20px auto 24.33px;
}

.emptySidebarIcon {
  display: block;
  width: 68.33px;
}

.sidebarItemWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 249px;
  margin-left: 24px;

  &:hover {
    .sidebarItem {
      text-decoration: none;

      &:not(.sidebarItemActive) {
        background: $white;
      }
    }

    .subSidebarItemsContainer {
      &:not(.subSidebarActive) {
        background: $white;
      }
    }
  }
}
</style>
